/* Upcoming occasions only: no prices, payment plans or calculator listeners. */
(function () {
  'use strict';

  function nextDate(card, today) {
    var mode = card.dataset.dateMode;
    var spec = card.dataset.date || '';
    if (!spec || mode === 'none') return null;
    if (mode === 'once') {
      var parts = spec.split('-').map(Number);
      if (parts.length !== 3) return null;
      var once = new Date(parts[0], parts[1] - 1, parts[2]);
      return once.getFullYear() === parts[0] && once.getMonth() === parts[1] - 1 && once.getDate() === parts[2] ? once : null;
    }
    var month = Number(spec.slice(0, 2)) - 1;
    if (month < 0 || month > 11 || !Number.isInteger(month)) return null;
    for (var year = today.getFullYear(); year <= today.getFullYear() + 8; year++) {
      var day = Number(spec.slice(3, 5));
      if (mode === 'nth') {
        var weekday = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'].indexOf(card.dataset.weekday || 'sun');
        var nth = Number(card.dataset.nth || 1);
        if (weekday < 0 || nth < 1 || nth > 5) return null;
        day = 1 + (weekday - new Date(year, month, 1).getDay() + 7) % 7 + (nth - 1) * 7;
      }
      var date = new Date(year, month, day);
      if (date.getMonth() === month && date.getDate() === day && date >= today) return date;
    }
    return null;
  }

  function boot() {
    var today = new Date();
    today.setHours(0, 0, 0, 0);
    document.querySelectorAll('[data-event-reminders]').forEach(function (list) {
      var cards = Array.prototype.map.call(list.querySelectorAll('[data-occasion]'), function (card) {
        var date = nextDate(card, today);
        var label = card.querySelector('[data-event-date]');
        card.hidden = !!date && date < today;
        if (label && date) {
          label.textContent = date.toLocaleDateString(list.dataset.dateLocale || 'en-US', {
            day: 'numeric', month: 'short', year: 'numeric'
          });
        }
        return { card: card, date: date };
      });
      cards.sort(function (a, b) {
        return (a.date ? a.date.getTime() : Infinity) - (b.date ? b.date.getTime() : Infinity);
      }).forEach(function (item) { list.appendChild(item.card); });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
